module.exports = __webpack_public_path__ + "static/media/experience_1.a00ede3f.svg";